import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`Mincemeat is a puzzle game based on the popular Lemmings series. The aim is to mince as many of your "meats" as possible, using the power-ups available for each level.`}</p>
    <p>{`The game was built in GameMaker, and converted to HTML5 using GameMaker studio.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      